// src/components/Canvas/IconRenderer.tsx

import React from 'react';
import {
  IconDefinition,
  IconRenderOptions
} from '@/features/components/iconPacks/types';

interface IconRendererProps extends IconRenderOptions {
  icon: IconDefinition;
  nodeId?: string;
}

export const IconRenderer: React.FC<IconRendererProps> = ({
  icon,
  size = 64,
  color = '#3b82f6',
  className = ''
}): React.ReactElement => {
  if ((icon.source === 'lucide' || !icon.source) && icon.icon) {
    const LucideIcon = icon.icon;
    return <LucideIcon size={size} color={color} className={className} />;
  }

  if (
    (icon.source === 'reshot' ||
      icon.source === 'cloud-provider' ||
      icon.source === 'custom') &&
    icon.svgPath
  ) {
    return (
      <img
        src={icon.svgPath}
        alt={icon.name}
        className={className}
        style={{
          width: size,
          height: size,
          objectFit: 'contain'
        }}
      />
    );
  }

  // Fallback - always return valid JSX
  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <span className="text-gray-400 text-xs">?</span>
    </div>
  );
};

/**
 * Icon Preview Component (for Component Library)
 */
interface IconPreviewProps {
  icon: IconDefinition;
  selected?: boolean;
  onClick?: () => void;
}

export const IconPreview: React.FC<IconPreviewProps> = ({
  icon,
  selected = false,
  onClick
}) => {
  return (
    <div
      className={`
        flex flex-col items-center justify-center p-4 
        rounded-lg cursor-pointer transition-all
        ${
          selected
            ? 'bg-blue-100 dark:bg-blue-900/30 border-2 border-blue-500'
            : 'bg-gray-50 dark:bg-slate-800 hover:bg-gray-100 dark:hover:bg-slate-700'
        }
      `}
      onClick={onClick}
    >
      <IconRenderer icon={icon} size={48} />
      <span className="text-xs mt-2 text-center text-gray-700 dark:text-gray-300">
        {icon.name}
      </span>
    </div>
  );
};
